<template>
  <div class="meet-timeline">
    <div class="tl-wrapper" v-for="(t, i) in list" :key="i">
      <div class="tl-line" v-show="list.length > 1"></div>
      <div class="tl-ball"></div>
      <div class="tl-item-wrapper">
        <div class="tl-item">
          <div class="tl-left" @click="listevent(t)">
            <template v-if="cmode == 1">
              <div class="tl-top">
                <!-- <div class="tl-time red">{{ t.N_UserDef1 }}</div> -->
                <div class="tl-title-cmode1">{{ t.C_TITLE }}</div>
              </div>
              <div class="tl-content">
                <div class="text" v-show="t.lecturers">
                  演讲嘉宾：{{ t.lecturers }}
                </div>
                <div class="text" v-show="t.meetname">
                  <b class="meetname">{{ t.meetname }}</b>
                </div>
                <div class="tl-foot">
                  <div class="tl-date" v-show="t.N_UserDef1">
                    <!-- <div class="date"> -->
                    <van-icon name="clock-o" />{{ t.N_UserDef1 }}
                    <!-- </div> -->
                    <!-- <div class="time">{{ t.N_UserDef1 }}</div> -->
                  </div>
                  <div class="tl-address" v-show="t.N_UserDef2">
                    <van-icon name="location-o" /> {{ t.N_UserDef2 }}
                  </div>
                </div>
              </div> </template
            ><template v-else>
              <div class="tl-top">
                <div class="tl-time">{{ t.N_UserDef1 }}</div>
                <div class="tl-title">{{ t.C_TITLE }}</div>
              </div>
              <div class="tl-content">
                <div class="text" v-show="t.lecturers">
                  演讲嘉宾：{{ t.lecturers }}
                </div>
                <div class="text">地点：{{ t.N_UserDef2 }}</div>
              </div>
            </template>
          </div>
          <div class="tl-right">
            <div class="star" @click.stop="collect(t)">
              <div v-if="t.isCollect">
                <van-icon name="star" class="red" />
                <div class="text">取消</div>
              </div>
              <div v-else>
                <van-icon name="star-o" class="gray" />
                <div class="text">收藏</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "meet-timeline",
  data() {
    return {
      //   isCollect: false,
    };
  },
  props: {
    list: {
      type: Array,
      default: [],
    },
    cmode: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    listevent(item) {
      this.$emit("listevent", item);
    },
    collect(item) {
      this.$emit("collect", item);
    },
  },
};
</script>
<style lang="scss">
.van-collapse-item__content {
  // background: $theme-bg-color;
  background: none;
}

.meet-timeline {
  .tl-wrapper {
    position: relative;
    // background: $theme-bg-color;
    .tl-line,
    .tl-ball {
      position: absolute;
    }
    .tl-ball {
      top: 16px;
      background: $theme-bg-color;
      width: 6px;
      height: 6px;
      left: 1px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tl-line {
      left: 4px;
      height: 100%;
      border-left: 2px solid $theme-bg-color;
    }
    .tl-item-wrapper {
      padding-bottom: 10px;
      .tl-item {
        background: #fff;
        padding: 10px;
        display: flex;
        border-radius: 5px;
        padding-bottom: 10px;
        margin-left: 15px;
        .tl-left {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          border-right: 1px dotted #ccc;
          padding-right: 10px;
          .tl-top {
            font-weight: bold;
            .tl-time {
              color: $theme-color;
              font-size: 16px;
            }
            .tl-title {
              font-size: 12px;
              color: #000;
            }
            .tl-title-cmode1 {
              font-size: 14px;
              color: #222;
            }
          }
          .tl-content {
            margin-top: 6px;
            .text {
              color: #606060;
              font-size: 12px;
              .meetname {
                color: $theme-color;
              }
            }

            .tl-foot {
              display: flex;
              font-size: 12px;
              color: #606060;
              justify-content: space-between;
              margin-top: 8px;
              .tl-date {
                display: flex;
                flex-wrap: wrap;
                .time {
                  margin-left: 10px;
                }
                // .date {
                .van-icon {
                  vertical-align: text-top;
                  margin-right: 3px;
                }
                // }
              }
              .tl-address {
                vertical-align: bottom;
                .van-icon {
                  vertical-align: text-top;
                }
              }
            }
          }
        }
        .tl-right {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 0px 15px;
          .star {
            // color: red;
            .van-icon {
              font-size: 15px;
            }
            .text {
              color: #000;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
.meet-timeline .tl-wrapper:first-child .tl-ball,
.meet-timeline .tl-wrapper:last-child .tl-ball {
  top: 16px;
  background: $theme-bg-color;
  width: 6px;
  height: 6px;
  left: 1px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.meet-timeline .tl-wrapper:first-child .tl-line {
  top: 16px;
  left: 4px;
  height: 100%;
  border-left: 2px solid $theme-bg-color;
}
.meet-timeline .tl-wrapper:last-child .tl-line {
  left: 4px;
  height: 16px;
  border-left: 2px solid $theme-bg-color;
}
</style>